// mindzera-frontend/src/builderUtils.js
export const typeForDepth = ['domain', 'skill', 'subskill', 'microskill'];

/* ---------- helpers to convert between tree <--> flat ---------- */
export function flattenTree(domains) {
  const rows = [];
  const walk = (arr, parent, depth) => {
    arr.forEach((n, idx) => {
      rows.push({
        id:         n.id,
        parent_id:  parent,
        name:       n.name,
        type:       typeForDepth[depth],
        position:   idx
      });
      if (n.children?.length) walk(n.children, n.id, depth + 1);
    });
  };
  walk(domains, null, 0);
  return rows;
}

export function treeify(flat) {
  const byId = Object.fromEntries(
    flat.map(n => [n.id, { ...n, children: [] }])
  );
  flat.forEach(n => {
    if (n.parent_id) byId[n.parent_id].children.push(byId[n.id]);
  });
  return flat.filter(n => n.parent_id === null).map(n => byId[n.id]);
}
